import { render, staticRenderFns } from "./DiagramFrequencySec.vue?vue&type=template&id=85835db2"
import script from "./DiagramFrequencySec.vue?vue&type=script&lang=js"
export * from "./DiagramFrequencySec.vue?vue&type=script&lang=js"
import style0 from "./DiagramFrequencySec.vue?vue&type=style&index=0&id=85835db2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports